module.exports = __webpack_public_path__ + "static/media/handelsbanken.310f77b9.svg";